//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CourseAssignmentDto } from '../../courseassignments/dto/CourseAssignmentDto';
import { IApiRequest } from '../../IApiRequest';

export class AddSelfAssignedCourseAssignmentRequest extends IApiRequest<CourseAssignmentDto[]>
{
	public $type = 'AddSelfAssignedCourseAssignmentRequest';
	constructor(public data: { companyId: string, courseId: string, activeFrom: string, activeTo: string }) { super(); }
}
